import useAppQueryParam from "@/hooks/useAppQueryParam";
import { useEffect } from "react";
import useAuthStore from "../store.auth";

const useNewUserParam = () => {
  const { getQueryParam, removeQueryParam } = useAppQueryParam();
  const { authOutcome, setAuthOutcome } = useAuthStore();

  useEffect(() => {
    if (getQueryParam("newUser") !== "true") return;

    // Never let a stale ?newUser=true flip a real login into a "new user"
    // (which would auto-download). Only honor it for actual fresh signups.
    if (authOutcome !== "existing-user") {
      setAuthOutcome("new-user");
    }

    // Consume the param so a refresh can't replay the auto-download.
    removeQueryParam("newUser");
  }, []);
};

export default useNewUserParam;
